import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { UiDetailExpandedComponent } from './components/detail-expanded/detail-expanded.component';
import { UiFormTableComponent } from './components/form-table/form-table.component';
import { UiTableCellActionComponent } from './components/table-cell-action/table-cell-action.component';
import { UiTableComponent } from './components/table/table.component';
import { AutoAbbrevDirective } from './directives/auto-abbrev/auto-abbrev.directive';
import { UiAutoSizeDirective } from './directives/auto-size/auto-size.directive';
import { AutomaticTableResizingDirective } from './directives/automatic-table-resizing/automatic-table-resizing.directive';
import { ClickableCellDirective } from './directives/clickable-cell/clickable-cell.directive';
import { ClickableRowDirective } from './directives/clickable-row/clickable-row.directive';
import { UiExpandedRowDirective } from './directives/expanded-row/expanded-row.directive';
import { UiTableFormOrchestratorDirective } from './directives/table-form-ochestrator/table-form-ochestrator.directive';
import { UiTableOrchestratorDirective } from './directives/table-orchestrator/table-orchestrator.directive';
import { WindowService } from './services/window.service';
import { CoreUiPrimaryButtonModule } from '../../../primary-button/src';
import { CoreFeaturesMediaIfModule } from '@brunsker/libs/core/features/media-if/src';
import { CoreUiValueHoverModule } from '../../../value-hover/src';
import { CoreUiTableActionsModule } from '../../../table-actions/src';
import { CoreUiInputIncrementorModule } from '../../../input-incrementor/src';
import { CoreFeaturesGenericPipeModule } from '@brunsker/libs/core/features/generic-pipe/src';
import { CoreFeaturesNoImageFoundModule } from '@brunsker/libs/core/features/no-image-found/src';
import { SimpleTableComponent } from './components/simple-table/simple-table.component';
import { TablePaginatorDirective } from './directives/table-paginator/table-paginator.directive';
import { SectionHeaderComponent } from './components/section-header/section-header.component';
import { TableScrollbarDirective } from './directives/table-scrollbar/table-scrollbar.directive';

import { InputSelectComponent } from '@brunsker/libs/portal-do-vendedor/ui/form-controls/lib/components/input-select/input-select.component';

@NgModule({
  imports: [
    InputSelectComponent,
    MatTableModule,
    CommonModule,
    CdkTableModule,
    MatPaginatorModule,
    MatIconModule,
    MatSortModule,
    MatSelectModule,
    MatButtonModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatRadioModule,
    FormsModule,
    MatMenuModule,
    CoreUiPrimaryButtonModule,
    CoreFeaturesMediaIfModule,
    CoreUiValueHoverModule,
    CoreUiTableActionsModule,
    MatFormFieldModule,
    MatInputModule,
    CoreUiInputIncrementorModule,
    CoreFeaturesGenericPipeModule,
    CoreFeaturesNoImageFoundModule,
    NgxPaginationModule,
    SectionHeaderComponent,
  ],
  declarations: [
    UiTableComponent,
    UiDetailExpandedComponent,
    UiExpandedRowDirective,
    UiTableOrchestratorDirective,
    UiTableCellActionComponent,
    UiAutoSizeDirective,
    UiFormTableComponent,
    UiTableFormOrchestratorDirective,
    ClickableCellDirective,
    AutoAbbrevDirective,
    AutomaticTableResizingDirective,
    ClickableRowDirective,
    SimpleTableComponent,
    TablePaginatorDirective,
    TableScrollbarDirective,
  ],
  exports: [
    UiTableComponent,
    UiDetailExpandedComponent,
    UiExpandedRowDirective,
    UiTableOrchestratorDirective,
    UiTableCellActionComponent,
    UiAutoSizeDirective,
    UiFormTableComponent,
    UiTableFormOrchestratorDirective,
    ClickableCellDirective,
    AutoAbbrevDirective,
    AutomaticTableResizingDirective,
    SimpleTableComponent,
    TablePaginatorDirective,
    TableScrollbarDirective,
    SectionHeaderComponent,
  ],


  providers: [
    {
      provide: WindowService,
      useClass: WindowService,
    },
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreUiTableModule {}
